import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { cn } from "@/lib/utils";

export function LanguageSwitcher({ invert = false }) {
  const { lang, setLang } = useLanguage();
  return (
    <div className={cn("inline-flex items-center rounded-sm border p-0.5 text-xs font-medium", invert ? "border-sidebar-border" : "border-border")}>
      {["de", "en"].map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          className={cn(
            "rounded-[3px] px-2 py-1 uppercase tracking-wide transition-colors",
            lang === l
              ? "bg-primary text-primary-foreground"
              : invert
                ? "text-sidebar-foreground/70 hover:text-sidebar-foreground"
                : "text-muted-foreground hover:text-foreground",
          )}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
